import { Component, ViewChild } from '@angular/core';
import { CommonService } from '../services/common-services/common.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { isEmpty } from 'lodash';
import { MatSidenav } from '@angular/material/sidenav';
import { OmsServiceService } from '../modules/oms/service/oms-service.service';
import { downloadUserManual } from '../shared/utils';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  visible?: boolean;
  route?: string;
  icon?: string;
}
@Component({
  selector: 'app-layout-manager',
  templateUrl: './layout-manager.component.html',
  styleUrls: ['./layout-manager.component.scss']
})
export class LayoutManagerComponent {
  title = 'customer-portal';
  isShowing:boolean = false;
  isExpanded: boolean = true;
  showSubmenu: boolean = false;
  permissionsData: any = '';
  @ViewChild('rightSidenav') public rightSidenav!: MatSidenav;
  rightSideNavView = 'addUser';
  sideNavList: any = [];
  selectedParent: string = '';
  baseUrl = environment.BASE_URL;
  activeItem!: string;
  routeUrl!: string ;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private breakpointObserver: BreakpointObserver,
    private commonService: CommonService,
    private omsService: OmsServiceService,
  ) {
    // this.dataSource.data = this.TREE_DATA;
    this.commonService.updateSidebarNav$.subscribe((updatedSideNavView: string) => {
      this.rightSideNavView = updatedSideNavView;
      this.rightSidenav.open();
    });
  }

  ngOnInit(): void {
    let permissions: any = sessionStorage.getItem('customerpermissionsData') || '{}';
    if (permissions) {
      let parsedPermissions: any = JSON.parse(permissions);
      if (parsedPermissions) {
        this.permissionsData = parsedPermissions?.module?.find(
          (item: any) => item.name == 'Customer' || 'Internal',
        );
        this.permissionsData?.menuList.forEach((item: any) => {
          const sideNavList: any = [];
          if (item.pageList.length > 0) {
            item.pageList.forEach((page: any) => {
              let subNavItem = {
                 route: page.url,
                //route: this.removeCustomerRoute(page.url),
                icon: page.icon,
                name: page.name,
                visible: page.status,
                displayOrder: page.displayOrder,
                parent: item.name,
              };
              if (page?.name !== 'Blank_Page') {
                sideNavList.push(subNavItem);
              }
            });
          }
          let navItem = {
            //route: this.removeCustomerRoute(item.url),
            route:item.url,
            icon: item.icon,
            name: item.name,
            visible: item.status,
            displayOrder: item.displayOrder,
            children: sideNavList,
          };
          this.sideNavList.push(navItem);
        });

        // Sorting parent items
        this.sideNavList.sort((a: any, b: any) => a.displayOrder - b.displayOrder);
      }
    }
    this.breakpointObserver.observe(['(max-width: 767px)']).subscribe((result) => {
      if (result.matches) {
        this.isExpanded = false;
      } else {
        this.isExpanded = false;
      }
    });
    this.isRouteActive();
  }

  isSubMenuOpen(parent: string): boolean {
    return this.selectedParent == parent;
  }

  getSubmenuItems(parent: string): any[] {
    return this.sideNavList.filter((item: any) => item.parent === parent);
  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  navigate(url: string) {
    if (!isEmpty(url)) {
      this.router.navigateByUrl(this.removeCustomerRoute(url));
      //this.router.navigateByUrl(url);
      this.isExpanded = false;
      this.isRouteActive(url);
    }
    this.resetOmsTab();
  }
  isRouteActive(urlItem?: string) {
    const url = urlItem || this.router.url;
    const updateUrl = urlItem || `/customer${url}`;
    this.routeUrl = updateUrl;
  }
  isChildActive(itemList: any[]): boolean {
    const url = this.router.url;
    const updateUrl = `/customer${url}`;
    return itemList.some((item: any) => {
      if (item.route === updateUrl) {
        return true;
      }
      return false;
    });
  }
  removeCustomerRoute(pageUrl:any){
    let itemUrl:any;
    let urlSegments:any = pageUrl.split('/');          
    if(urlSegments[0] === 'customer'){
      urlSegments.shift();
      itemUrl = `/${urlSegments.join('/')}`
    } else if(urlSegments[0] === '' && urlSegments[1] === 'customer'){
      urlSegments.splice(1, 1);
      itemUrl = `${urlSegments.join('/')}`
    } else{
      itemUrl = pageUrl.url;
    }
    return itemUrl
  }
  resetOmsTab() {
    this.omsService.omsCurrentTab = null;
  }
  setActiveItem(itemName: string, sideNav: any) {
    if (sideNav.children.length) {
      this.isExpanded = true;
    } else {
      this.isExpanded = false;
    }
    if (this.activeItem === itemName) {
      //this.activeItem = '';
    } else {
      this.activeItem = itemName;
    }
  }

  closeRightSideNav() {
    this.rightSidenav.close();
  }
  isDevMode() {
    const isDev = !environment.production ? true : false;
    return isDev;
  }
  downloadGuide() {
    let fileName = 'Customer-User-Guide';
    downloadUserManual(this.baseUrl, this.commonService, this.toastr, fileName);
  }
}
